import { BaseQueryFn, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import Cookies from "js-cookie";

import { BEARER_COOKIE_NAME } from "@tsp/api/utils/bearerAuth";
import { selectEnvValues } from "@tsp/app/features/env";

import { getExceptionCode, getExceptionFromUnknown } from "@tsp-core/exception/utils";
import { showNotification } from "@tsp-core/notifier/slice";
import { checkIsString } from "@tsp-core/utils/string";

export const baseQuery: BaseQueryFn = async (args, api, extraOptions: any = {}) => {
  const { DOCFLOW_SERVER_ORIGIN } = selectEnvValues(api.getState() as any);

  try {
    const result = await fetchBaseQuery({
      baseUrl: DOCFLOW_SERVER_ORIGIN,
      prepareHeaders: (headers) => {
        const token = Cookies.get(BEARER_COOKIE_NAME);
        if (token) {
          headers.set("Authorization", `Bearer ${token}`);
        }

        return headers;
      },
    })(args, api, extraOptions);

    if (result.error) {
      const exception = getExceptionFromUnknown<Record<string, unknown>>(result.error);
      const errorCode = Number(getExceptionCode(result.error));
      const suppressStatuses = extraOptions.suppressGlobalErrorNotificationStatuses as Array<number> | undefined;
      const suppressGlobalErrorNotification = Array.isArray(suppressStatuses) && suppressStatuses.includes(errorCode);

      if (!suppressGlobalErrorNotification) {
        if (!extraOptions.hideDetailsNotifications) {
          const details = exception.getDetails();
          if (details) {
            Object.entries(details).forEach(([key, message]) => {
              if (checkIsString(message)) {
                api.dispatch(showNotification({ type: "error", message: `${key}: ${message}` }));
              }
            });
          }
        }

        api.dispatch(showNotification({ type: "error", message: exception.getMessage() }));
      }
    }

    return result;
  } catch (error) {
    const exception = getExceptionFromUnknown<Record<string, unknown>>(error);

    if (!extraOptions.hideDetailsNotifications) {
      const details = exception.getDetails();
      if (details) {
        Object.entries(details).forEach(([key, message]) => {
          if (checkIsString(message)) {
            api.dispatch(showNotification({ type: "error", message: `${key}: ${message}` }));
          }
        });
      }
    }

    api.dispatch(showNotification({ type: "error", message: exception.getMessage() }));

    throw error;
  }
};
